import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Globe } from 'lucide-react';

const Footer = () => {
  const [mostrarPolitica, setMostrarPolitica] = useState(false);

  return (
    <motion.footer 
      className="bg-gradient-to-r from-red-700 to-red-900 text-white py-16 px-6"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 mb-12">
          {/* --- Columna 1 --- */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 bg-white/20 rounded-xl">
                <img 
                  src="/images/fe5.png" 
                  alt="Logo ELEMENT5 Química Aplicada" 
                  className="w-12 h-12 object-contain" 
                />
              </div>
              <div>
                <h3 className="text-xl font-bold">ELEMENT5</h3>
                <p className="text-red-100 text-sm">Química Aplicada</p>
              </div>
            </div>
            <p className="text-red-100 leading-relaxed">
              Revolucionamos la industria de la construcción con productos químicos innovadores y servicios especializados que optimizan cada proyecto
            </p>
          </motion.div>

          {/* --- Columna 2 --- */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <h4 className="text-lg font-bold mb-6 text-white">Nuestras Soluciones</h4>
            <ul className="space-y-3 text-red-100">
              <li className="hover:text-white transition-colors cursor-pointer">Aditivos</li>
              <li className="hover:text-white transition-colors cursor-pointer">Construcción</li>
              <li className="hover:text-white transition-colors cursor-pointer">Desarrollo de ingeniería</li>
              <li className="hover:text-white transition-colors cursor-pointer">Asesorías Técnicas</li>
            </ul>
          </motion.div>

          {/* --- Columna 3 --- */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            <h4 className="text-lg font-bold mb-6 text-white">Nuestros Productos</h4>
            <ul className="space-y-3 text-red-100">
              <li className="hover:text-white transition-colors cursor-pointer">Acelerantes</li>
              <li className="hover:text-white transition-colors cursor-pointer">Reductores de agua</li>
              <li className="hover:text-white transition-colors cursor-pointer">Especialidades</li>
              <li className="hover:text-white transition-colors cursor-pointer">Adiciones</li>
              <li className="hover:text-white transition-colors cursor-pointer">Estabilizadores</li>
              <li className="hover:text-white transition-colors cursor-pointer">Inclusores/Exclusores de aire</li>
            </ul>
          </motion.div>

          {/* --- Columna 4 --- */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
          >
            <h4 className="text-lg font-bold mb-6 text-white">Contacto</h4>
            <div className="space-y-4">
              <div className="flex items-center gap-3 text-red-100">
                <Mail className="w-5 h-5 text-white" />
                <span>contacto@element5.mx</span>
              </div>
              <div className="flex items-center gap-3 text-red-100">
                <Phone className="w-5 h-5 text-white" />
                <span>+52 5524842236</span>
              </div>
              <div className="flex items-center gap-3 text-red-100">
                <MapPin className="w-10 h-10 text-white" />
                <a 
                  href='https://maps.app.goo.gl/K1mn8PPGrH6i8tp79' 
                  target='_blank' 
                  className='hover:underline'
                >
                  AV. Lago de Guadalupe 127, Margarita Masa de Juarez, 52926 Cdad. López Mateos, Méx.
                </a>
              </div>
              <div className="flex items-center gap-3 text-red-100">
                <Globe className="w-5 h-5 text-white" />
                <a href='https://element5.mx/' target='_blank' className='hover:underline'>
                  ELEMENT5.mx
                </a>
              </div>
            </div>
          </motion.div>
        </div>

        {/* --- Política de Gestión Integral --- */}
        <motion.div 
          className="border-t border-white/30 pt-8 text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          <h4 className="text-lg font-bold mb-4 text-white">
            POLÍTICA DE GESTIÓN INTEGRAL
          </h4>

          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: mostrarPolitica ? "auto" : 0, opacity: mostrarPolitica ? 1 : 0 }}
            transition={{ duration: 0.5 }}
            className="overflow-hidden"
          >
            <p className="text-red-200 leading-relaxed mt-4">
              Element5 Química Aplicada somos una empresa mexicana, generadora de conocimiento e innovación aplicadas a la tecnología del concreto, a nivel especializado. 
              Contamos con la atención y respuesta satisfactoria a las expectativas de nuestras partes interesadas, en el cumplimiento de los requisitos legales y aplicables para nuestra organización en productos y servicios. 
              Desarrollamos nuestras soluciones de manera sustentable, con bajo impacto ambiental, asegurándonos de que todas nuestras operaciones se desarrollen en un ambiente seguro para nuestros colaboradores, a través de la aplicación, mantenimiento y mejora continua de nuestro sistema de gestión integral (ISO 9001, ISO 14001 e ISO 45001).
              <br /><br />
              <strong>Óscar D. González Amante</strong><br />
              Director General
            </p>
          </motion.div>

          <button
            onClick={() => setMostrarPolitica(!mostrarPolitica)}
            className="mt-4 px-4 py-2 bg-white/20 hover:bg-white/30 rounded-lg transition"
          >
            {mostrarPolitica ? "Ocultar" : "Ver más"}
          </button>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;